import CryptoJS from 'crypto-js'
import axios from 'axios'
/**
 *加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    key = CryptoJS.enc.Latin1.parse(key)
    param.forEach(ele => {
      var data = result[ele]
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}
// 方向转化
export const direction = (angle) => {
  // 北方向
  if (angle >= 0 && angle <= 22 || angle >= 338 && angle <= 360) {
    return '1'
  }
  // 东北方向
  if (angle >= 23 && angle <= 67) {
    return '2'
  }
  // 东方向
  if (angle >= 68 && angle <= 112) {
    return '3'
  }
  // 东南方向
  if (angle >= 113 && angle <= 157) {
    return '4'
  }
  // 南方向
  if (angle >= 158 && angle <= 202) {
    return '5'
  }
  // 西南方向
  if (angle >= 203 && angle <= 247) {
    return '6'
  }
  // 西方向
  if (angle >= 248 && angle <= 292) {
    return '7'
  }
  // 西北方向
  if (angle >= 293 && angle <= 337) {
    return '8'
  }
}
// 表格空数据处理
export const emptyFn = (row, column, cellValue) => {
  let str = ''
  if (cellValue || cellValue === 0) {
    if (column.property.search('Price') != -1 || column.property.search('taxation') != -1) {
      str = format(2, cellValue)
    } else if (column.property.search('Money') != -1) {
      str = format(2, cellValue)
    } else if (column.property.search('eight') != -1) {
      if (row.unitMeasurement) {
        str = cellValue + row.unitMeasurement
      } else {
        str = format(3, cellValue)
      }
    } else {
      str = cellValue
    }
  } else {
    str = '-'
  }
  function format (n, num) {
    var result = parseFloat(num)
    let str = ''
    if (isNaN(result)) {
      str = num
    } else {
      let a = Math.pow(10, n)
      result = Math.round(num * a) / a
      var s_x = result.toString()
      var pos_decimal = s_x.indexOf('.')
      if (pos_decimal < 0) {
        pos_decimal = s_x.length
        s_x += '.'
      }
      while (s_x.length <= pos_decimal + n) {
        s_x += '0'
      }
      str = s_x
    }

    return str
  }
  return str
}
// 时间格式化
// flag 1:'YYYY-MM-dd hh-mm',2:'YYYY-MM'
export const dateTimeFormat = (row, column, cellValue, index, flag) => {
  var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
  var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
  var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
  var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
  var str = ''
  if (cellValue == null) {
    str = '-'
  } else if (flag == 1) {
    str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes
  } else if (flag == 2) {
    str = t.getFullYear() + '-' + month
  } else {
    str =
      t.getFullYear() +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hour +
      ':' +
      minutes +
      ':' +
      seconds
  }
  return str
}
// 时间格式化
export const dateTimeFormat1 = (row, column, cellValue) => {
  var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
  var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
  var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
  var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
  var str = ''
  if (cellValue == null || cellValue == '' || cellValue == undefined) {
    str = '-'
  } else {
    str =
      t.getFullYear() +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hour +
      ':' +
      minutes +

      ':' +
      seconds
  }
  return str
}
// 日期格式化-年月
export const dateFormatYM = (row, column, cellValue) => {
  var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
  var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  var str = ''
  if (cellValue == null) {
    str = '-'
  } else {
    str =
      t.getFullYear() +
      '-' +
      month
  }
  return str
}
// 日期格式化
export const dateFormat = (row, column, cellValue) => {
  var str = ''
  if (!cellValue) {
    str = '-'
  } else {
    var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
    var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
    var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
    str =
      t.getFullYear() +
      '-' +
      month +
      '-' +
      date
  }
  return str
}
export const dateFormat1 = (date, type = '-') => {
  if (date == null) {
    return
  }
  const dat = new Date(date)
  const year = dat.getFullYear()
  const month = (dat.getMonth() + 1).toString().padStart(2, 0)
  const day = (dat.getDate()).toString().padStart(2, 0)
  const hours = (dat.getHours()).toString().padStart(2, 0)
  const minutes = (dat.getMinutes()).toString().padStart(2, 0)
  const second = (dat.getSeconds()).toString().padStart(2, 0)
  if (type == 'CHN') {
    return `${year} 年 ${month} 月 ${day} 日`
  } else if (type == '/') {
    return `${year}/${month}/${day}/`
  } else if (type == 'CHN-YYYY-MM-ss h-m-s') {
    return `${year}年${month}月${day}日 ${hours}:${minutes}:${second}`
  } else if (type == 'YYYY-MM-ss h-m-s') {
    return `${year}-${month}-${day} ${hours}:${minutes}:${second}`
  } else if (type == 'YYYY-MM-ss h-0-0') {
    return `${year}-${month}-${day} ${hours}:00:00`
  } else {
    return `${year}-${month}-${day}`
  }
}
export const toFixed = (num, precision = 2) => {
  if (precision < 0 || precision > 20) {
    throw new RangeError('precision must be between 0 and 20')
  }

  const number = +num
  if (isNaN(number) || !isFinite(number)) return '0'

  // 核心修复：使用更精确的舍入因子
  const factor = Math.pow(10, precision)

  // 处理负号
  const sign = number < 0 ? -1 : 1
  const absNum = Math.abs(number)

  // 精确舍入（使用字符串避免浮点误差）
  const rounded = Math.round((absNum * factor + Number.EPSILON) * 100) / 100
  const result = Math.round(rounded) / factor

  return (sign * result).toFixed(precision)
}
/* eslint no-extend-native: ["error", { "exceptions": ["Number"] }] */
Number.prototype.toFixed = function (n) {
  if (n > 20 || n < 0) {
    throw new RangeError('toFixed() digits argument must be between 0 and 20')
  }
  const number = this
  if (isNaN(number) || number >= Math.pow(10, 21)) {
    return number.toString()
  }
  if (typeof (n) == 'undefined' || n == 0) {
    return (Math.round(number)).toString()
  }

  let result = number.toString()
  const arr = result.split('.')

  // 整数的情况
  if (arr.length < 2) {
    result += '.'
    for (let i = 0; i < n; i += 1) {
      result += '0'
    }
    return result
  }

  const integer = arr[0]
  const decimal = arr[1]
  if (decimal.length == n) {
    return result
  }
  if (decimal.length < n) {
    for (let i = 0; i < n - decimal.length; i += 1) {
      result += '0'
    }
    return result
  }
  result = integer + '.' + decimal.substr(0, n)
  const last = decimal.substr(n, 1)

  // 四舍五入，转换为整数再处理，避免浮点数精度的损失
  if (parseInt(last, 10) >= 5) {
    const x = Math.pow(10, n)
    result = (Math.round((parseFloat(result) * x)) + 1) / x
    result = result.toFixed(n)
  }

  return result
}
// 无内容显示占位符(疏港列表重量无内容处理)
export const formatterRowEmpty = (row, column, cellValue, index) => {
  // console.log(Boolean(cellValue), cellValue);
  if (!cellValue) {
    return '-'
  } else {
    if (column.label.search('（元）') != -1 || column.label.search('(元)') != -1) {
      return cellValue.toLocaleString('en-US', { minimumFractionDigits: 2,
        maximumFractionDigits: 2 })
    } else {
      return cellValue
    }
  }
}
// 数组差集 flag 1、求A数组比B数组多得值，2、求B数组比A数组多得值
export const arrChaJi = (arrA, arrB, flag) => {
  let jiaoArr = arrA.filter(function (val) { return arrB.indexOf(val) > -1 })
  let resultArr = []
  if (flag == 1) {
    resultArr = arrA.filter(function (val) { return jiaoArr.indexOf(val) === -1 })
  } else {
    resultArr = arrB.filter(function (val) { return jiaoArr.indexOf(val) === -1 })
  }
  return resultArr
}

/*
 * JS 时间格式化
 * type 时间格式（yyyy-MM-dd hh:ii:ss / MM-dd / hh:ii / yyyy-MM）可自定义
 * date 毫秒时间戳（1554954127000）
 * 使用：timeFormat('yyyy-MM-dd hh:ii:ss',1554954127000)
 * 说明：紧支持毫秒级时间戳，传统秒级 Unix 时间戳需要乘以 1000 转换为毫秒
 */
export const dateFormatUtil = (type, date) => {
  var date = new Date(date)
  var o = {
    'M+': date.getMonth() + 1,	// 月份
    'd+': date.getDate(),		// 日
    'h+': date.getHours(),		// 小时
    'i+': date.getMinutes(),	// 分
    's+': date.getSeconds()	// 秒
  }
  if (/(y+)/.test(type)) {
    type = type.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(type)) {
      type = type.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    };
  }
  return type
}
// 一维数组根据相同的属性值分成二维数组
export function sortArr (arr, str) {
  var _arr = []
  var _t = []
  // 临时的变量
  var _tmp

  // 按照特定的参数将数组排序将具有相同值得排在一起
  arr = arr.sort(function (a, b) {
    var s = a[str]
    var t = b[str]

    return s < t ? 1 : -1
  })

  if (arr.length) {
    _tmp = arr[0][str]
  }
  // console.log( arr );
  // 将相同类别的对象添加到统一个数组
  for (var i in arr) {
    // console.log( _tmp);
    if (arr[i][str] === _tmp) {
      // console.log(_tmp)
      _t.push(arr[i])
    } else {
      _tmp = arr[i][str]
      _arr.push(_t)
      _t = [arr[i]]
    }
  }
  // 将最后的内容推出新数组
  _arr.push(_t)
  return _arr
}
// 数字转换为大写金额
export function ToString (n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return '数据非法' // 判断数据是否大于0
  }

  var unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
  var str = ''
  n += '00'

  var indexpoint = n.indexOf('.') // 如果是小数，截取小数点前面的位数

  if (indexpoint >= 0) {
    n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2) // 若为小数，截取需要使用的unit单位
  }

  unit = unit.substr(unit.length - n.length) // 若为整数，截取需要使用的unit单位
  for (var i = 0; i < n.length; i++) {
    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i) // 遍历转化为大写的数字
  }
  console.log(str)

  return str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|壹(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元整') // 替换掉数字里面的零字符，得到结果
}
/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
// 乘以100保留两位小数点
export function multipliedByHundred (str) {
  let floatVal = parseFloat(str)
  if (isNaN(floatVal)) {
    return 0
  }
  floatVal = Math.round(str * 10000) / 100
  let strVal = floatVal.toString()
  let searchVal = strVal.indexOf('.')
  if (searchVal < 0) {
    searchVal = strVal.length
    strVal += '.'
  }
  while (strVal.length <= searchVal + 2) {
    strVal += '0'
  }
  return parseFloat(strVal)
}
export function IdentityCodeValid (code) {
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  var tip = ''
  var pass = true
  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    tip = '身份证号格式错误'
    pass = false
  } else if (!city[code.substr(0, 2)]) {
    tip = '地址编码错误'
    pass = false
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      var last = parity[sum % 11]
      if (parity[sum % 11] != code[17]) {
        tip = '校验位错误'
        pass = false
      }
    }
  }
  return pass
}
export function viewPdf (content) {
  if (!content) {
    this.$message.error('暂无意见')
    return
  }
  const blob = base64ToBlob(content)
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob)
  } else {
    const fileURL = URL.createObjectURL(blob)
    // window.open(fileURL)
    newLink(fileURL)
  }
  function newLink (url) {
    let newLink = window.open('loading page')
    axios.get(url)
      .then(function (response) {
        newLink.location.href = url
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  function base64ToBlob (code) {
    code = code.replace(/[\n\r]/g, '')
    // atob() 方法用于解码使用 base-64 编码的字符串。
    const raw = window.atob(code)
    const rawLength = raw.length
    const uInt8Array = new Uint8Array(rawLength)
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i)
    }
    return new Blob([uInt8Array], { type: 'application/pdf' })
  }
}
export function accSub (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) // last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}
// 获取最近一个月时间
export const getLastMonth = () => {
  let startDatr = dateFormat1(new Date().getTime() - 1000 * 60 * 60 * 24 * 30)
  let endDate = dateFormat1(new Date().getTime())
  startDatr = startDatr + ' 00:00:00'
  endDate = endDate + ' 23:59:59'
  return [startDatr, endDate]
}
// 获取本月1号到当前时间
export const getMorenTime = () => {
  const now = new Date()
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
  let startDatr = dateFormat1(firstDay)
  let endDate = dateFormat1(new Date().getTime())
  startDatr = startDatr + ' 00:00:00'
  endDate = endDate + ' 23:59:59'
  return [startDatr, endDate]
}
// 获取最近一周时间
export const getLastWeekDates = (type) => { // riqi、shijian
  let dates = []
  for (let i = 0; i < 7; i++) {
    let date = new Date()
    date.setDate(date.getDate() - i)
    let year = date.getFullYear()
    let month = date.getMonth() + 1 // 月份是从0开始的
    let day = date.getDate()
    // 格式化月份和日期，保持两位数
    month = ('0' + month).slice(-2)
    day = ('0' + day).slice(-2)
    dates.unshift(year + '-' + month + '-' + day) // 将格式化的日期添加到数组前面
  }
  if (type == 'riqi') {
    return [dates[0], dates[6]]
  } else {
    return [dates[0] + ' 00:00:00', dates[6] + ' 23:59:59']
  }
}
